export const FETCH_ACCOUNT = 'FETCH_ACCOUNT'
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS'

export const fetchAccount = () => {
  return {
    type: FETCH_ACCOUNT
  }
}

export const fetchAccountSuccess = (account) => {
  return {
    type: FETCH_ACCOUNT_SUCCESS,
    payload: account
  }
}
